// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homePpopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

}

.homePpopup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  position: relative;
  text-align: left;
  width: 40%;
}

.homeSelectInput[type="file"] {
  display: none;
}

.homePopupBtn {
  width: 100%;
  border: none !important;
  padding: 1.5%;
  border-radius: 2px;
  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 4%;
  height: 40px;
}
.homePopupBtnShort {
  width: 45%;
  border: none !important;
  padding: 1.5%;
  border-radius: 2px;
  /* background-color: #35b276 !important; */
  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 4%;
  height: 40px;
  margin-left: 2.5%;
  margin-right: 2.5%;
  border-radius: 30px;
}

.homePopupBtn:hover {
  width: 100%;
  padding: 1.5%;
  border-radius: 2px;
  /* background-image: url("../images/bg.png"); */
  /* color: black; */
  border: 2px solid #ecf8e5 !important;
}

.homePopupBtnShort:hover {
  /* background-image: url("../images/bg.png"); */
  /* color: black; */
  border: 1px solid black !important;
}

.uploadResumeInput{
  margin-left: 2.5%;
  margin-right: 2.5%;
  width: 95%;
}


.popupImg {
  position: absolute;
  width: 8%;
  left: 1%;
  top: 10%;
}

.homeHeader {
  color: #17213A;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  position: relative;
  text-align: center !important;
  margin-bottom: 4%;
  font-size: 25px;
  padding-top: 2%;
}

.homeSelectOption {
  color: #17213A;
  padding-left: 1.3%;
}

.newResumeBtn {

  width: 100%;
  border: none !important;
  padding: 1.5%;
  border-radius: 2px;
  /* background-color: #35b276; */
  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
  color: white;
  height: 40px;

}

.newResumeBtn:hover {
  width: 100%;
  padding: 1.5%;
  border-radius: 2px;
  /* background-image: url("../images/bg.png"); */
  /* color: black; */
  border: 2px solid #ecf8e5 !important;

}

.jobHomeHeader {
  color: #35b276;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  position: relative;
  text-align: center !important;
  margin-bottom: 4%;
  font-size: 25px;
  padding-top: 2%;
}
.jobDetailsInfoLabel {
  font-size: 16px;
  margin-top: 1%;
  margin-bottom: 3%;
  color: rgb(130, 139, 162);
  font-size: 15px;
  line-height: 18px;
}

.detailsInfoInput {
  border-radius: 3px;
  padding: 6px 10px;
  width: 95%;
  caret-color: rgb(26, 145, 240);
  background-color: rgb(239, 242, 249);
  outline: none;
  border: 0px;
  color: rgb(30, 37, 50);
  transition: color 0.1s ease 0s;
  margin-bottom: 4%;
}
.savePositionNow {
  width: 100%;
  border: none !important;
  padding: 1.5%;
  border-radius: 2px;
  background-color: #35b276;
  color: white;
  height: 40px;
}

.savePositionNow:hover {
  width: 100%;
  padding: 1.5%;
  border-radius: 2px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: black;
  border: 2px solid #ecf8e5 !important;
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/createUpload.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,yFAAyF;EACzF,8IAA8I;EAC9I,2FAA2F;EAC3F,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,kEAAkE;EAClE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,kEAAkE;EAClE,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;;AAEtC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,oCAAoC;EACpC,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yDAAyC;EACzC,YAAY;EACZ,oCAAoC;AACtC","sourcesContent":[".homePpopup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n\n}\n\n.homePpopup-content {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n  position: relative;\n  text-align: left;\n  width: 40%;\n}\n\n.homeSelectInput[type=\"file\"] {\n  display: none;\n}\n\n.homePopupBtn {\n  width: 100%;\n  border: none !important;\n  padding: 1.5%;\n  border-radius: 2px;\n  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 4%;\n  height: 40px;\n}\n.homePopupBtnShort {\n  width: 45%;\n  border: none !important;\n  padding: 1.5%;\n  border-radius: 2px;\n  /* background-color: #35b276 !important; */\n  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 4%;\n  height: 40px;\n  margin-left: 2.5%;\n  margin-right: 2.5%;\n  border-radius: 30px;\n}\n\n.homePopupBtn:hover {\n  width: 100%;\n  padding: 1.5%;\n  border-radius: 2px;\n  /* background-image: url(\"../images/bg.png\"); */\n  /* color: black; */\n  border: 2px solid #ecf8e5 !important;\n}\n\n.homePopupBtnShort:hover {\n  /* background-image: url(\"../images/bg.png\"); */\n  /* color: black; */\n  border: 1px solid black !important;\n}\n\n.uploadResumeInput{\n  margin-left: 2.5%;\n  margin-right: 2.5%;\n  width: 95%;\n}\n\n\n.popupImg {\n  position: absolute;\n  width: 8%;\n  left: 1%;\n  top: 10%;\n}\n\n.homeHeader {\n  color: #17213A;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  position: relative;\n  text-align: center !important;\n  margin-bottom: 4%;\n  font-size: 25px;\n  padding-top: 2%;\n}\n\n.homeSelectOption {\n  color: #17213A;\n  padding-left: 1.3%;\n}\n\n.newResumeBtn {\n\n  width: 100%;\n  border: none !important;\n  padding: 1.5%;\n  border-radius: 2px;\n  /* background-color: #35b276; */\n  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n  color: white;\n  height: 40px;\n\n}\n\n.newResumeBtn:hover {\n  width: 100%;\n  padding: 1.5%;\n  border-radius: 2px;\n  /* background-image: url(\"../images/bg.png\"); */\n  /* color: black; */\n  border: 2px solid #ecf8e5 !important;\n\n}\n\n.jobHomeHeader {\n  color: #35b276;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  position: relative;\n  text-align: center !important;\n  margin-bottom: 4%;\n  font-size: 25px;\n  padding-top: 2%;\n}\n.jobDetailsInfoLabel {\n  font-size: 16px;\n  margin-top: 1%;\n  margin-bottom: 3%;\n  color: rgb(130, 139, 162);\n  font-size: 15px;\n  line-height: 18px;\n}\n\n.detailsInfoInput {\n  border-radius: 3px;\n  padding: 6px 10px;\n  width: 95%;\n  caret-color: rgb(26, 145, 240);\n  background-color: rgb(239, 242, 249);\n  outline: none;\n  border: 0px;\n  color: rgb(30, 37, 50);\n  transition: color 0.1s ease 0s;\n  margin-bottom: 4%;\n}\n.savePositionNow {\n  width: 100%;\n  border: none !important;\n  padding: 1.5%;\n  border-radius: 2px;\n  background-color: #35b276;\n  color: white;\n  height: 40px;\n}\n\n.savePositionNow:hover {\n  width: 100%;\n  padding: 1.5%;\n  border-radius: 2px;\n  background-image: url(\"../images/bg.png\");\n  color: black;\n  border: 2px solid #ecf8e5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
